import React from 'react';

interface CurrencyItemProps {
  currency?: string;
  children: string | number;
}

const CurrencyItem = ({ children = '', currency = 'USD' }: CurrencyItemProps) => {
  const stripped = typeof children === 'string' ? parseFloat(children.replace(/[$,]+/g, '') || '0') : children;
  const formatted = stripped.toLocaleString('en-US', { style: 'currency', currency });

  return (
    <>
      <span className="text-bold" style={{ color: 'var(--green-5)' }}>
        $
      </span>
      {formatted.replace(/\$/, '')}
    </>
  );
};

export default CurrencyItem;
